<template>
  <ion-page>
    <ion-header>
      <div class="navbar">
        <img class="nav-icon" :src="getBrandImageUrl('xiaoyu.png')" alt="" @click="onClose" />
        语法点
      </div>
      <!-- <ion-toolbar class="topbar">
        <ion-buttons slot="start">
          <ion-button @click="onClose">返回</ion-button>
        </ion-buttons>
        <ion-title>语法知识点</ion-title>
      </ion-toolbar> -->
    </ion-header>
    <ion-content>
      <div id="grammar_knowledge" class="grammar_knowledge"></div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonHeader, IonContent } from "@ionic/vue";
import { getBrandImageUrl } from "@/js/brandImages";
export default {
  name: "GrammarKnowledge",
  components: {
    IonPage,
    IonHeader,
    IonContent,
  },
  props: ["chapterId"],

  mounted() {
    this.getGrammarChapterKnowledge();
  },

  methods: {
    getBrandImageUrl,
    getGrammarChapterKnowledge() {
      this.ajax.post("/grammar/getGrammarChapter?chapterId=" + this.chapterId).then((res) => {
        if (res.data.success) {
          document.getElementById("grammar_knowledge").innerHTML = res.data.data.knowledge;
        }
      });
    },
  },
};
</script>

<style scoped>
ion-toolbar {
  --background: #645fa9;
  --padding: 0;
  --margin: 0;
  --border: none;
}

.grammar_knowledge {
  line-height: 2rem;
  display: block;
  color: black;
  background-color: white;
  width: 92vw;
  margin: 22px auto;
}
/* new ui  */

.navbar {
  height: 44px;
  line-height: 44px;
  text-align: center;
  position: relative;
}
.nav-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translate(0, -50%);
}
ion-header::after {
  display: none;
}
ion-header {
  background: #fff;
}
ion-content {
  --background: #fff;
}
</style>
